(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
const tihexReviewObservers = new WeakMap();
function initialiseTihexReviewLanguage() {
  document.querySelectorAll('[data-tihex-review-title]').forEach((section) => {
    if (tihexReviewObservers.has(section)) return;
    const applyLanguage = () => {
      section.querySelectorAll('.jdgm-cards-carousel .jdgm-title').forEach((heading) => {
        if (heading.textContent !== section.dataset.tihexReviewTitle) heading.textContent = section.dataset.tihexReviewTitle;
      });
      section.querySelectorAll('.jdgm-cards-carousel .jdgm-arrow').forEach((button) => {
        const label = button.getAttribute('aria-label') || '';
        if (label === 'Previous slide') button.setAttribute('aria-label', section.dataset.tihexReviewPrevious);
        if (label === 'Next slide') button.setAttribute('aria-label', section.dataset.tihexReviewNext);
      });
    };
    const observer = new MutationObserver(applyLanguage);
    observer.observe(section, { childList: true, subtree: true, characterData: true });
    tihexReviewObservers.set(section, observer);
    applyLanguage();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseTihexReviewLanguage, { once: true });
} else {
  initialiseTihexReviewLanguage();
}
document.addEventListener('shopify:section:load', initialiseTihexReviewLanguage);
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-tihex-review-title]').forEach((section) => {
    const observer = tihexReviewObservers.get(section);
    if (observer) observer.disconnect();
    tihexReviewObservers.delete(section);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-with-text"] && !Shopify.designMode) return;
  try {
    
function tihexMotionInit(){
document.querySelectorAll('.tihex-motion:not([data-motion-initialized])').forEach(root=>{
root.dataset.motionInitialized='true';
const track=root.querySelector('.section-grid'), button=root.querySelector('.tihex-motion__pause');
const originals=Array.from(track.children), reduced=window.matchMedia('(prefers-reduced-motion: reduce)'), mobile=window.matchMedia('(max-width:749px)');
let animation, paused=false, hovered=false;
function sync(){if(animation){if(paused||hovered||root.matches(':focus-within'))animation.pause();else animation.play();}}
function build(){
if(animation)animation.cancel();
track.querySelectorAll('[data-motion-copy]').forEach(n=>n.remove());
if(reduced.matches||!mobile.matches){root.removeAttribute('data-ready');return;}
root.dataset.ready='true';
const distance=originals.reduce((sum,n)=>sum+n.getBoundingClientRect().width,0);
if(!distance)return;
const copies=Math.max(1,Math.ceil(root.clientWidth/distance));
for(let i=0;i<copies;i++)originals.forEach(n=>{const clone=n.cloneNode(true);clone.removeAttribute('id');clone.removeAttribute('data-shopify-editor-block');clone.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));clone.setAttribute('aria-hidden','true');clone.setAttribute('inert','');clone.dataset.motionCopy='true';track.appendChild(clone);});
animation=track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+distance+'px)'}],{duration:distance/24*1000,iterations:Infinity,easing:'linear'});
sync();
}
button.addEventListener('click',()=>{paused=!paused;button.setAttribute('aria-pressed',String(paused));button.firstElementChild.textContent=paused?'▶':'Ⅱ';sync();});
root.addEventListener('mouseenter',()=>{hovered=true;sync();});
root.addEventListener('mouseleave',()=>{hovered=false;sync();});
root.addEventListener('focusin',sync);
root.addEventListener('focusout',()=>requestAnimationFrame(sync));
new ResizeObserver(build).observe(root);
reduced.addEventListener('change',build);
mobile.addEventListener('change',build);
build();
});
}
tihexMotionInit();
document.addEventListener('shopify:section:load',tihexMotionInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tihex-compact-finder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const opener=event.target.closest('[data-tihex-vehicle-open]');
 const dialog=document.getElementById('TihexVehicleDialog');
 if (!dialog) return;
 if(opener){dialog.showModal();return;}
 if(event.target.closest('[data-tihex-vehicle-close]')) dialog.close();
 if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tihex-engine-kits"] && !Shopify.designMode) return;
  try {
    
function tihexKitPlaceholder(){
document.querySelectorAll('.tihex-ek .globo-formbuilder').forEach(el=>{
if(el.dataset.tihexPlaceholderInit)return;
el.dataset.tihexPlaceholderInit='true';
function updatePlaceholder(){
const placeholder=el.querySelector('[id="167313-select"] option[disabled][value=""]');
if(placeholder&&placeholder.textContent==='Nog geen voorkeur')placeholder.textContent='Kies uitvoering';
}
updatePlaceholder();
const observer=new MutationObserver(updatePlaceholder);
observer.observe(el,{childList:true,subtree:true});
setTimeout(()=>observer.disconnect(),30000);
});
}
tihexKitPlaceholder();
document.addEventListener('shopify:section:load',tihexKitPlaceholder);

  } catch(e) { console.error(e); }
})();
})();
